
import React, { useEffect, useRef } from "react";
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import uniqid from 'uniqid';

import ScrollButtons from './ScrollButtons';
import GameTile from "./GameTile";
import getImageSrc from "../utils/get-image-src";
import CategoryLinkNoIcon from "./CategoryLinkNoIcon";
import CategoryTitle from "./CategoryTitle";
import CategoryLinkIconLeft from "./CategoryLinkIconLeft";


export default function FilterRow() {
    const country = useSelector((state) => state.globalContent.data.country)
    const gameCategories = useSelector((state) => state.gameCategories.list || null);
    const category = gameCategories ? (gameCategories[`filter-${country.ISOcode}`] || gameCategories['filter']) : null;
    const locale = useSelector((state) => state.globalContent.data.locale);

    const container = useRef(null);

    useEffect(() => { });

    return (
        <Container fluid="lg" className="game-row-container section-margin" >
            {/* <h3 className="h3 mb-3">Pick your category</h3> */}
            <div className="filter-row-title-wrapper">
                <CategoryTitle title="Pick your category" className="mt-0" />
                <Link to={`/${locale}/games/all-games`} className="mt-0 mb-3 filter-row-title-link">5,027 games</Link>
            </div>

            {/* Row */}
            <div className="position-relative">
                <div className="filter-row-wrapper" ref={container}>

                    {/* Games */}
                    {
                        category && (
                            category.categories.map((subcategory, i) => {
                                return (
                                    <CategoryLinkIconLeft 
                                        to={`games/${subcategory.url}`}
                                        key={`filter-row-${i}`}
                                        title={subcategory?.title}
                                        src={subcategory?.imageUrl}
                                        style={{minWidth: "300px"}}
                                    />
                                )
                            })
                        )
                    }
                </div>

                {/* Scroll */}
                <ScrollButtons container={container} />
            </div>
        </Container>
    );
}